import { customFetch, getAll, getById, remove, update } from "./baseService";

const userService = {
  getAllUsers: () => {
    return getAll('users')
  },
  getUserById: (user_id) => {
    return getById('users',user_id)
  },
  updateUser: (user_id,user) => {
    return update('users',user_id,user)
  },
  deleteUser: (user_id) => {
    return remove('users',user_id)
  },
  getMe: () => {
    return customFetch('users/getMe')
  },
  updateAvatar: async (file, user_id) => {
    const formData = new FormData();
    formData.append('file', file);

    return customFetch(`users/updateAvatar`, {
      method: 'POST',
      body: formData,
    });
  },
}

export default userService
